import React, {FC, useMemo} from 'react';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';
import {CheckoutItemType} from 'desktop/types/checkoutItemsType';
import {flags} from 'libs/rollout';

import {SupplyText} from '../../supplyText/supplyText';

import {QuantitySelector} from './quantitySelector/quantitySelector';
import {RebateContentCheckout} from './rebateContentCheckout/rebateContentCheckout';
import {SubscriptionSupplyBlock} from './subscriptionSupplyBlock/subscriptionSupplyBlock';

export type PropsType = {
    item: CheckoutItemType;
};
/**
 * Contact lenses subscription and quantity blocks
 */
export const LensesSubscriptionQuantity: FC<PropsType> = ({item}) => {
    const {prescription, rebateDiscounts} = item;

    const maxDiscountRebate = useMemo(() => {
        if (rebateDiscounts?.length === 0) return null;

        return rebateDiscounts?.reduce((prev, curr) => {
            return curr.discount > prev.discount ? curr : prev;
        });
    }, [rebateDiscounts]);

    const isRebate = maxDiscountRebate && flags.clRebate.isEnabled();
    const minRebateableBoxes = rebateDiscounts && rebateDiscounts[0]?.qty;
    const boxesCount = Number(prescription?.od.boxes) + Number(prescription?.os.boxes);
    const isRebatePassed = boxesCount >= Number(minRebateableBoxes);

    const rebateBlock = useMemo(() => {
        if (!isRebate) return null;

        const commonProps = {
            isRebatePassed,
            maxDiscountRebate,
        };

        return <RebateContentCheckout {...commonProps} />;
    }, [isRebate, isRebatePassed, maxDiscountRebate]);

    return (
        <SubscriptionSupplyBlock
            item={item as unknown as QuoteItemV2}
            supplyComponent={<SupplyText item={item as unknown as QuoteItemV2} />}
        >
            {rebateBlock}
            <QuantitySelector isRebatePassed={isRebatePassed} item={item} />
        </SubscriptionSupplyBlock>
    );
};
